import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { IReferenceCardProps } from '@/@types/photostudio';

export function ReferenceCard({
  label,
  icon: Icon,
  imageUrl,
  onClick,
  onClear,
  disabled = false,
}: IReferenceCardProps) {
  const hasImage = !!imageUrl;

  return (
    <div
      className={cn(
        'relative h-[90px] min-h-[90px] max-h-[90px] rounded-lg border bg-background-input overflow-hidden transition-colors',
        'border-border hover:border-border-hover',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      )}
      onClick={disabled ? undefined : onClick}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onKeyDown={e => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {hasImage ? (
        <>
          <img src={imageUrl} alt={label} className="h-full w-full object-cover" />
          {onClear && !disabled && (
            <button
              type="button"
              onClick={e => {
                e.stopPropagation();
                onClear();
              }}
              className={cn(
                'absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full',
                'bg-black/60 text-white/80 hover:bg-black/80 hover:text-white',
                'transition-colors'
              )}
              aria-label={`Clear ${label}`}
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </>
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-1 p-3">
          <Icon className="h-7 w-7 text-foreground-placeholder" />
          <span className="text-[13px] font-medium text-foreground-muted text-center">{label}</span>
          <span className="text-foreground-placeholder text-sm">+</span>
        </div>
      )}
    </div>
  );
}
